import { Controller } from "@hotwired/stimulus"
import { renderStreamMessage } from "@hotwired/turbo";

// Connects to data-controller="admin-thesis"
export default class extends Controller {
  static targets = [
    'course',
  ]
  static values = {
    getThesisThemesUrl: String,
  }

  changeCourse(event) {
    if (!event.target.value) {
      if (this.hasCourseTarget) {
        this.disableSelect([this.courseTarget])
      }
      return
    }
    
    const query = new URLSearchParams()
    query.set('course_id', event.target.value)
    query.set('user_id', event.target.dataset.userId)

    let url = this.getThesisThemesUrlValue

    fetch(`${url}?${query}`, { headers: { "Accept": "text/vnd.turbo-stream.html" } })
      .then(resonse => resonse.text())
      .then(message => {
        renderStreamMessage(message)
        console.log(message)
        this.enableSelect([this.courseTarget])
      })
  }

  disableSelect(targets, holdValue = false) {
    targets.forEach(target => {
      if (!target) {
        return
      }

      if (!holdValue) {
        target.value = null
      }
      target.disabled = true
    })
  }

  enableSelect(targets) {
    targets.forEach(target => {
      if (!target) {
        return
      }

      target.disabled = false
    })
  }
}
